import gql from 'graphql-tag';

export const GET_VEHICLE_BY_LICENSE_PLATE_NUMBER = gql`query getVehicleAssemblyByLicensePlateNumber($country: String!, $state: String!, $licensePlate: String!) {
  vehicleSelection {
    vehicleAssemblyByLicensePlateNo(country: $country, state: $state, licensePlate: $licensePlate) {
      isStaggered
      frontPSI
      rearPSI
      frontAssembly
      rearAssembly
      isNonOE
      trimName
      trimId
      assemblyId
      vehicleId
     rideHeights {
      id
      description
      type
    }
     vehicleAssembly{
      vehicleAssemblyID
      vehicle {
        id
        make
        model
        vehicleLargeImage {
          url
        }
        vehicleSmallImage {
          url
          
        }
        type
        year
      }
      trim {
        id
        description
        chassis {
          drive {
            driveType
            dual
            fuelType
          }
          hubData {
            lugTorque
          }
        }
        vehicleCategory
  		}
      rideHeight {
    description
    id
    type
  }
  assembly {
    id
    tireDiameter
    placardPSI 
  }
}
  }
  }
}`;
